import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'
import SequenceController from '../playground/controllers/SequenceController'

let randomizeTimeout, mouseWheelTimeout

class HomePlayController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initInstructions()
    // this.initPlayground()
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e) 
    this.destroyPlayground()
  }
  addEventListeners() {
    super.addEventListeners()
    $(window).on('resize', $.proxy(this.onWindowResize, this))
    $("body").on('click', '.editionhome-instructions', $.proxy(this.onInstructionsClick, this))
    $("body").on('mousemove', $.proxy(this.onMouseMove, this))
    $("body").on('mousedown touchstart', $.proxy(this.onMouseDown, this))
    $("body").on('mouseup touchend', $.proxy(this.onMouseUp, this))
    $("body").on('keydown', $.proxy(this.onKeyDown, this))
    
  }
  removeEventListeners() {
    super.removeEventListeners()
    $(window).off('resize', $.proxy(this.onWindowResize, this))
    $("body").off('click', '.editionhome-instructions', $.proxy(this.onInstructionsClick, this))
    $("body").off('mousemove', $.proxy(this.onMouseMove, this))
    $("body").off('mousedown touchstart', $.proxy(this.onMouseDown, this))
    $("body").off('mouseup touchend', $.proxy(this.onMouseUp, this))
    $("body").off('keydown', $.proxy(this.onKeyDown, this))
  }
  /**
   * ###########
   * ### OWN ###
   */
  // init instructions
  initInstructions() {
    const footer = this.getFooter()
    if (footer) {
      TweenMax.set(footer, {y: footer.offsetHeight + 50})
    }
    const instr = this.getInstr()
    if (instr) {
      const list = [...instr.querySelectorAll(".instr-item")]
      TweenMax.from(list, 1.4, {opacity: 0, delay: (i) => i*.3, ease: Sine.easeOut})
    }
  }
  onInstructionsClick(e) {
    if (e) {
      e.preventDefault();
    }
    const instr = this.getInstr()
    if (instr) {
      const list = [...instr.querySelectorAll(".instr-item")]
      TweenMax.killTweensOf(list)
      TweenMax.to(list, .5, {opacity: 0, delay: (i) => i*.07, ease: Power3.easeIn, onComplete: () => {
        instr.style.display = "none"
        instr.style.visibility = "hidden"
        console.log(instr.style)
      }})
    }
    const footer = this.getFooter()
    if (footer) {
      TweenMax.to(footer, .5, {y: 0, ease: Power4.easeOut, delay: 5})
    }
    setTimeout(() => {
      this.initPlayground()
    }, 1000)
  }
  getInstr() {
    return document.querySelector(".editionhome-instructions")
  }
  getFooter() {
    return document.querySelector(".editionhome-footer")
  }
  // # init Playground
  initPlayground() {    
    this.sequencer = new SequenceController()
    this.sequencer.sequenceStart()
  }
  // # destroy Playground
  destroyPlayground() {
    if (this.sequencer) {
      this.sequencer.sequenceStop()
    }
  }
  onKeyDown(e) {
    if (this.sequencer) {
      this.sequencer.onKeyDown(e)
    } else {
      this.onInstructionsClick()
    }
  }
  onMouseDown(e) {
    if (this.sequencer) {
      this.sequencer.onMouseDown({x: e.pageX, y: e.pageY})
    }
  }
  onMouseUp(e) {
    if (this.sequencer) {
      this.sequencer.onMouseUp({x: e.pageX, y: e.pageY})
    }
  }
  onMouseMove(e) {
    if (this.sequencer) {
      this.sequencer.onMouseMove({x: e.pageX, y: e.pageY})
    }
  }

  // # On window resize
  onWindowResize(e) {
    if (this.sequencer) {
      this.sequencer.onWindowResize()
    }
  }
  
  
  


}

export default HomePlayController;